import * as types from './Constants'

export const increaseEvaluationStep = () => {
  return { type: types.INCREASE_EVALUATION_STEP }
}

export const decreaseEvaluationStep = () => {
  return { type: types.DECREASE_EVALUATION_STEP }
}
